import { initThemer, subscribeTheme, getCssVar, getCssVars } from '../chunk-CDSUSZHW.js';
import { useRef, useState, useEffect, useCallback, useSyncExternalStore, createElement, Fragment } from 'react';

function useTheme(options = {}) {
  const instanceRef = useRef(null);
  const optionsRef = useRef(options);
  if (instanceRef.current === null) {
    instanceRef.current = initThemer(optionsRef.current);
  }
  const [, force] = useState(0);
  useEffect(() => {
    if (instanceRef.current === null) {
      instanceRef.current = initThemer(optionsRef.current);
      force((n) => n + 1);
    }
    const unsub = subscribeTheme(() => force((n) => n + 1));
    return () => {
      unsub();
      instanceRef.current?.destroy();
      instanceRef.current = null;
    };
  }, []);
  const setPreference = useCallback((p) => {
    instanceRef.current?.setPreference(p);
  }, []);
  const inst = instanceRef.current;
  const resolved = inst ? inst.resolved : "light";
  const toggle = useCallback(() => {
    const current = instanceRef.current;
    if (current === null) return;
    current.setPreference(current.resolved === "dark" ? "light" : "dark");
  }, []);
  return {
    preference: inst ? inst.preference : "auto",
    resolved,
    setPreference,
    toggle
  };
}
function subscribe(cb) {
  return subscribeTheme(cb);
}
function useThemeVar(name, fallback) {
  const get = useCallback(() => getCssVar(name, fallback), [name, fallback]);
  return useSyncExternalStore(
    subscribe,
    get,
    () => fallback ?? ""
    // SSR snapshot
  );
}
function useThemeVars(names) {
  const namesKey = names.join("|");
  const snapshotRef = useRef({
    key: "",
    theme: null,
    value: {}
  });
  const getSnapshot = useCallback(() => {
    const currentTheme = typeof document !== "undefined" ? document.documentElement.getAttribute("data-theme") : null;
    const snap = snapshotRef.current;
    if (snap.key === namesKey && snap.theme === currentTheme) {
      return snap.value;
    }
    const next = getCssVars(names);
    snapshotRef.current = { key: namesKey, theme: currentTheme, value: next };
    return next;
  }, [names, namesKey]);
  return useSyncExternalStore(subscribe, getSnapshot, () => ({}));
}
function ThemeProvider({ children, ...options }) {
  useTheme(options);
  return createElement(Fragment, null, children);
}

export { ThemeProvider, useTheme, useThemeVar, useThemeVars };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map